/**
 * The action routers answer failures with `{ error: <message> }`, so an axios
 * error's own message is only ever "Request failed with status code 400". A
 * rejected dependency has something specific to say — which task already
 * depends on this one — and it is worth showing.
 */
export function actionErrorMessage(error: unknown): string {
  const fromServer = (error as { response?: { data?: { error?: unknown } } })
    ?.response?.data?.error;
  if (typeof fromServer === 'string' && fromServer.trim() !== '')
    return fromServer;
  return error instanceof Error ? error.message : 'Something went wrong.';
}
